import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { publicRoutes } from 'app/public/routes/public-routes';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(publicRoutes)
  ],
  exports: [ RouterModule ]
})
export class PublicRoutingModule { }
